import ingredientsImg from 'assets/images/stylingGel/confirmationInterstitial/ingredients.png';
import lightImg from 'assets/images/stylingGel/confirmationInterstitial/light-hold.png';
import mediumImg from 'assets/images/stylingGel/confirmationInterstitial/medium-hold.png';
import strongImg from 'assets/images/stylingGel/confirmationInterstitial/strong-hold.png';
import stylingGelJar from 'assets/images/stylingGel/confirmationInterstitial/styling-gel-jar.png';

const content = {
  title: firstname => (
    <>
      <span>{`${firstname} custom styling`}</span>
      <br />
      <span>gel is ready</span>
    </>
  ),
  description: 'We’ve updated your profile with these new answers',
  image: stylingGelJar,
  imageAlt: 'styling gel jar',
  recommendation: {
    highly_recommended: { title: 'HIGHLY RECOMMENDED FOR YOU' },
    recommended: { title: 'RECOMMENDED FOR YOU' },
    not_recommended: { title: 'OPTIONAL FOR YOU' },
  },
  holdLevel: {
    strong: {
      title: 'STRONG HOLD LEVEL:',
      description: 'Our maximum hold for next-level, non-crunchy definition',
      image: strongImg,
      alt: 'woman who choosed a strong hold',
    },
    medium: {
      title: 'MEDIUM HOLD LEVEL:',
      description: 'Flexible hold for non-crunchy definition',
      image: mediumImg,
      alt: 'woman who choosed a medium hold',
    },
    light: {
      title: 'LIGHT HOLD LEVEL:',
      description: 'Minimal hold for subtle, non-crunchy definition',
      image: lightImg,
      alt: 'woman who choosed a light hold',
    },
  },
  ingredients: {
    title: 'KEY INGREDIENTS:',
    description:
      'Hydrating aloe vera, sea moss for moisture and smoothness, plus okra for frizz control and definition',
    image: ingredientsImg,
    alt: 'okra, sea moss & aloe vera',
  },
};

export default content;
